import { render, staticRenderFns } from "./genjinIgnore.vue?vue&type=template&id=2a818f15&scoped=true&"
import script from "./genjinIgnore.vue?vue&type=script&lang=js&"
export * from "./genjinIgnore.vue?vue&type=script&lang=js&"
import style0 from "./genjinIgnore.vue?vue&type=style&index=0&id=2a818f15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a818f15",
  null
  
)

export default component.exports